import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { caixaUser } from 'sharedKernel/user/CaixaUser';
import { cookies, setCookie } from 'sharedKernel/cookies/behavior';

export type UserRole = 'solucionador' | 'avaliador';

interface CaixaRoleContextData {
  selectedRole: UserRole;
  setSelectedRole: (role: UserRole) => void;
  isCaixaUser: boolean;
}

const CaixaRoleContext = createContext<CaixaRoleContextData | undefined>(undefined);

interface CaixaRoleProviderProps {
  children: ReactNode;
}

export const CaixaRoleProvider: React.FC<CaixaRoleProviderProps> = ({ children }) => {
  // Recuperar do cookie se existir, senão usar default
  const [selectedRole, setSelectedRoleState] = useState<UserRole>(() => {
    const savedRole = cookies.get('_caixaRole');
    return (savedRole === 'avaliador' || savedRole === 'solucionador') ? savedRole : 'solucionador';
  });
  const [isCaixaUser, setIsCaixaUser] = useState(false);

  const setSelectedRole = (role: UserRole) => {
    setSelectedRoleState(role);
    // Salvar no cookie para persistir entre sessões
    setCookie('_caixaRole', role);
  };

  useEffect(() => {
    const checkCaixaUser = () => {
      const isUserFromCaixa = caixaUser.isCaixaUser();
      setIsCaixaUser(isUserFromCaixa);
    };

    checkCaixaUser();
  }, []);

  const value: CaixaRoleContextData = {
    selectedRole,
    setSelectedRole,
    isCaixaUser
  };

  return (
    <CaixaRoleContext.Provider value={value}>
      {children}
    </CaixaRoleContext.Provider>
  );
};

export const useCaixaRole = (): CaixaRoleContextData => {
  const context = useContext(CaixaRoleContext);
  if (context === undefined) {
    throw new Error('useCaixaRole must be used within a CaixaRoleProvider');
  }
  return context;
};
